import { Component, OnInit } from "@angular/core";
import { FormGroup, FormArray, Validators } from "@angular/forms";
import { MemberappBaseComponent } from "../groupportal-base/groupportal-base.component";
import {
	ChapterDetails,
	ChapterInfo
} from "../../../shared/models/chapter-details";

declare var moment: any;
@Component({
	selector: 'history .d-flex.pl-3',
	templateUrl: './history.component.html',
	styleUrls: ["./history.component.scss"]
})

export class HistoryComponent extends MemberappBaseComponent {
	ui_stateprovinces: any = [];
	ngOnInit() {
		this.refreshStateProvinces();
	}

	changeSortDate() {
		this.groupPortalDataService.sortInvoiceDateAscending = (!this.groupPortalDataService.sortInvoiceDateAscending || this.groupPortalDataService.invoicesSortedBy !== 'date');
		this.groupPortalDataService.invoicesSortedBy = 'date';
		this.groupPortalDataService.changeSortInvoiceDate();
	}

	changeSortGBNumber() {
		this.groupPortalDataService.sortGBNumberAscending = (!this.groupPortalDataService.sortGBNumberAscending || this.groupPortalDataService.invoicesSortedBy !== 'GBNumber');
		this.groupPortalDataService.invoicesSortedBy = 'GBNumber';
		this.groupPortalDataService.changeSortInvoiceGBNumber();
	}

	changeSortStatus() {
		this.groupPortalDataService.sortInvoiceStatusAscending = (!this.groupPortalDataService.sortInvoiceStatusAscending || this.groupPortalDataService.invoicesSortedBy !== 'status');
		this.groupPortalDataService.invoicesSortedBy = 'status';
		this.groupPortalDataService.changeSortInvoiceStatus();
	}

	changeSortAmount() {
		this.groupPortalDataService.sortInvoiceAmountAscending = (!this.groupPortalDataService.sortInvoiceAmountAscending || this.groupPortalDataService.invoicesSortedBy !== 'amount');
		this.groupPortalDataService.invoicesSortedBy = 'amount';
		this.groupPortalDataService.changeSortInvoiceAmount();
	}

	onCountrySelect(countrycode) {
		this.refreshStateProvinces();
	}

	refreshStateProvinces() {
		//debugger;

		if (!!this.groupPortalDataService.groupList.GroupInfo) {
			if (this.dataService.uidata) {
				this.ui_stateprovinces = this.dataService.uidata.StateProvinces.filter(
					s => s.countrycode === this.groupPortalDataService.groupList.GroupInfo.country
				);
			}
			if (!this.groupPortalDataService.groupList.GroupInfo.state || this.groupPortalDataService.findObjectByKey(this.ui_stateprovinces, 'acep_isocode', this.groupPortalDataService.groupList.GroupInfo.state).length < 1) {
				this.groupPortalDataService.groupList.GroupInfo.state = "";
			}
		}
	}

	public SantizeDate(date: string): string {
		if (date == "" || date == null) return "";
		return moment(date).format('MM/DD/YYYY');
	}
}
